export default "__VITE_ASSET__WFD62egg__"